export const CLEAR_EXCEPTION = 'CLEAR_EXCEPTION';
export const CLOSE_EXCEPTION = 'CLOSE_EXCEPTION';

export function clearException(index) {
  return {
    type: CLEAR_EXCEPTION,
    index
  };
}

export function closeException(index) {
  return {
    type: CLOSE_EXCEPTION,
    index
  };
}
